import { SegmentType } from "./chartOfAccounts.types";

export const NOCODE = "NOCODE";

export const REQUIRED_SEGMENT_TYPES = [SegmentType.Fund, SegmentType.Object];
